import { TaxonomyType } from "data/types";
import Link from "components/Link";
import React, { FC } from "react";
import { DEMO_POSTS_VIDEO } from "data/posts";

export interface TagProps {
  className?: string;
  tag: TaxonomyType;
  hideCount?: boolean;
}
function getTotalVideo(catID:any)
{
  let counter=0;
  DEMO_POSTS_VIDEO.forEach(function(video:any)
  {
    if(video.categories[0].id === catID) 
    {
      counter++;
    }
  })
  return counter;
}

const Tag: FC<TagProps> = ({ className = "", tag, hideCount = false }) => {
  return (
    <Link
      className={`nc-Tag inline-block bg-white hover:bg-neutral-50 text-sm text-neutral-600 dark:text-neutral-300 py-2 px-3 rounded-lg md:py-2.5 md:px-4 dark:bg-neutral-900 ${className}`}
      href={tag.href}
    >
      {`${tag.name}`}
      {!hideCount && (
        <span className="text-xs font-normal"> ({getTotalVideo(tag.id)})</span>
      )}
    </Link>
  );
};

export default Tag;
